import { render, staticRenderFns } from "./MultipleChoiceV1.vue?vue&type=template&id=5ebb6638&"
import script from "./MultipleChoiceV1.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports